import axios from '@/plugins/axios';

class StoreRebindLogApi {
  static getLogs(
    page = 1,
    limit = 10,
    storeName = '',
    optNickName = '',
  ) {
    return axios({
      url: '/api/sys/log/store-rebind/page',
      data: {
        page,
        limit,
        store_name: storeName,
        opt_nick_name: optNickName,
      },
      method: 'post',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '查询门店换绑日志信息',
        },
      },
    });
  }
}

export default StoreRebindLogApi;
